import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { registerPublishedSqlDatasets } from 'tio-reporting/utils/sql-dataset-registration';
import { registerOpenSearchDatasetCatalog } from 'tio-reporting/utils/open-search-dataset-registration';
import type SessionContextService from 'tio-employee/services/session-context';
import type RouterService from '@ember/routing/router-service';
import type { Store as StoreService } from '@warp-drive/core';

const ALLOWED_ROLES = ['TIO_ADMIN', 'EMPLOYEE_ADMIN', 'ACCOUNT_OWNER'];

export default class AuthenticatedAdminReportingRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;
  @service declare store: StoreService;

  async beforeModel() {
    if (!this.sessionContext.isLoaded) {
      try {
        await this.sessionContext.load();
      } catch (e) {
        console.error('Could not load session context:', e);
      }
    }

    const hasAccess = this.sessionContext.roles.some((role) =>
      ALLOWED_ROLES.includes(role.relationshipType)
    );

    if (!hasAccess) {
      this.router.transitionTo('authenticated.dashboard');
      return;
    }

    // SQL slugs are only safe to register once the OpenSearch keys they must not collide with are known.
    if (await registerOpenSearchDatasetCatalog(this.store)) {
      await registerPublishedSqlDatasets(this.store);
    }
  }
}
